import { ActionState } from 'services/EpdClient';
import styled, { css } from 'styled-components';
import { Input, Label } from 'styles/Styles.styled';

export const AccordionLink = styled.div`
  cursor: pointer;
  align-self: center;
  padding-left: 1rem;
  &:hover {
    text-decoration: underline;
  }
`;

export const FixedLabel = styled(Label)`
  flex: 0 0 200px;
  align-self: center;
  margin: 0.5rem 1rem 0.5rem 0;
  display: flex;
  gap: 0.25rem;
  > svg {
    margin: 0;
  }

  > div + svg {
    margin: 0;
  }
`;

export const FixedLabelTop = styled(FixedLabel)`
  align-self: auto;
`;

export const FixedRow = styled.div<{ state?: ActionState }>`
  display: ${(props) => (props?.state === ActionState.Hidden ? 'none' : 'flex')};

  padding: 0.5rem 0;
`;

export const WizardStep1Row = styled.div<{ state?: ActionState }>`
  display: ${(props) => (props?.state === ActionState.Hidden ? 'none' : 'grid')};
  grid-template-rows: 3;
  grid-column-gap: 10px;
  grid-row-gap: 5px;
  justify-content: left;
  align-items: center;
  
  grid-template-columns: 100%;

  ${(props) => props.theme.media.desktop} {
    grid-template-columns: 2fr 4fr 1fr;
  }

  ${(props) =>
    props.state === ActionState.Disabled &&
    css`
      label {
        color: gray;
      }
    `}
`;

export const FixedTextArea = styled.textarea`
  width: 100%;
  height: 100px;
  margin: 0.5rem 0 1rem 0;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
  padding: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  border-color: #808080;

  &:disabled {
    background-color: rgb(242, 242, 242);
    color: ${(props) => props.theme.colors.elementDisabledTextColor};
  }
`;

export const epdSelectStyles = {
  menu: (styles: any) => ({ ...styles }),
  control: (styles: any) => ({
    ...styles,
    borderRadius: 0,
    borderColor: 'gray',
    color: 'black',
    fontSize: '14px',
    minHeight: '49px',
    margin: '0.5rem 0 ',
  }),
  singleValue: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled ? '#545454' : 'black',
  }),
  multiValueLabel: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled ? '#545454' : 'black',
    fontSize: '100%',
  }),
};

export const FixedTextInput = styled(Input)`
  flex: 1 0 auto;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
`;

export const SelectWrapper = styled.div`
  flex: 1 0 0;
  margin: 0.5rem 0 1rem 0;
`;
